export const HTTP_COMPANY_ID_HEADER_KEY = 'x-api-company-id';
